import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>© 2013 The Muslim Connection</p>
    </footer>
  );
};

export default Footer;
